import { css } from '@microsoft/fast-element';

export const genericButtonStyling = css`
  zero-button:hover svg path {
    fill: var(--white);
  }
`;

export const gridButtonStyling = css`
  zero-grid-pro::part(gridButton) {
    margin: 0px;
    height: 22px;
    min-width: 100%;
    font-size: 12px;
    color: var(--white);
    border-radius: 4px;
    border: 1px solid;
    background-image: linear-gradient(
      -102.62987429787164deg,
      rgba(169, 255, 120, 0.1) 0%,
      rgba(11, 214, 146, 0.1) 100%
    );
    box-sizing: border-box;
    border-image-source: linear-gradient(to left, var(--primary-color), var(--secondary-color));
    border-image-slice: 1;
  }

  zero-grid-pro::part(hyperlink):hover {
    text-decoration: underline;
  }
  zero-grid-pro::part(hyperlink) {
    color: var(--primary-color);
    cursor: pointer;
  }

  zero-grid-pro::part(actionWrapper) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  zero-grid-pro::part(iconsAndLink) {
    display: flex;
    width: 100%;
    gap: 5px;
  }

  zero-grid-pro::part(iconWrapper) {
    display: flex;
    align-items: center;
  }

  zero-grid-pro::part(leftButtons) {
    padding: 3px;
    display: flex;
    justify-content: flex-start;
    flex: 1;
  }

  zero-grid-pro::part(rightButtons) {
    padding: 2px 0px;
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  zero-grid-pro::part(gridIconButton) {
    background-color: rgba(255, 255, 255, 0.05);
    min-width: auto;
    font-size: 13px;
    color: var(--font-color-1);
    margin: 0px;
    width: 26px;
    height: 25px;
    justify-content: center;
  }

  zero-grid-pro::part(awaitingConfirmationButton) {
    width: 100%;
    height: 22px;
    padding: 2px 8px 2px 8px;
    border-radius: 2px;
    border: 1px solid rgba(255, 182, 96, 0.99);
    background-color: rgba(255, 182, 96, 0.19);
    box-sizing: border-box;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: rgba(255, 182, 96, 0.99);
    text-align: center;
    line-height: normal;
  }

  zero-grid-pro::part(inProgressButton) {
    width: 100%;
    height: 22px;
    padding: 2px 8px 2px 8px;
    border-radius: 2px;
    border: 1px solid rgb(245, 233, 25);
    background-color: rgba(245, 233, 25, 0.2);
    box-sizing: border-box;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: rgb(245, 233, 25);
    text-align: center;
    line-height: normal;
  }

  zero-grid-pro::part(confirmTradeButton) {
    width: 100%;
    height: 22px;
    padding: 2px 8px 2px 8px;
    border-radius: 2px;
    border: 1px solid var(--completed);
    background-color: rgba(122, 204, 121, 0.18);
    box-sizing: border-box;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: var(--completed);
    text-align: center;
    line-height: normal;
  }

  zero-grid-pro::part(rejectTradeButton) {
    width: 100%;
    height: 22px;
    padding: 2px 8px 2px 8px;
    border-radius: 4px;
    border: 1px solid #f9644d;
    background-color: rgba(249, 100, 77, 0.19);
    box-sizing: border-box;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: #f9644d;
    text-align: center;
    line-height: normal;
    cursor: auto;
  }
`;
